import { useState } from "react";
import { useNavigate } from "react-router-dom";
import searchImage from "../assets/img/search.svg";
import searchIcon from "../assets/img/search_icon.svg";
import { CustomerData } from "../config/CustomerData.js";
import { post } from "../api/services.js";
import Spinner from "./Spinner.js";
import { whitelistText } from "../utility/whitelistText.js";

const CustomerSearch = () => {
  const navigate = useNavigate();
  const [searchName, setSearchName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredCustomer, setFilteredCustomer] = useState([]); // State to store API response
  const [loading, setLoading] = useState(false); // State to handle loading
  const [error, setError] = useState(null); // State to handle errors

  const handleSkipClick = () => {
    navigate("/onboardingscreen");
  };

  const handleSearchClick = async () => {
    if (!searchName.trim()) {
      setError("Please enter a customer name.");
      return;
    }
    if (searchName.length > 100) {
      setError("Customer Name must be less than or equal to 100 characters.");
      return;
    }
    if (!whitelistText(searchName)) {
      setError("Customer Name contains invalid characters.");
      return;
    }
    if (!fromDate) {
      setError("Please select a Form Date.");
      return;
    }
    if (!toDate) {
      setError("Please select a To Date.");
      return;
    }

    setLoading(true); // Start loading
    setError(null); // Reset error state
    try {
      const response = await post("/getCustomerOffers", {
        customername: searchName,
        fromDate: fromDate,
        toDate: toDate,
      });

      if (response && response.status == 200) {
        setFilteredCustomer(response); // Set the API response to state
        navigate("/customersearch1", {
          state: {
            filteredCustomer: response,
            customerName: searchName,
            selectedFromDate: fromDate,
            selectedToDate: toDate,
          },
        });
      } else {
        // If no data is found, show an error message
        setError("No customer found.");
      }
    } catch (err) {
      setError("Failed to fetch customer offers. Please try again.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <section className="multistep_sec">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="row align-items-center">
              <div className="col-md-4"></div>
              <div className="col-md-8">
                <div
                  className="disclaimer_sec"
                  style={{ justifyContent: "flex-start", marginBottom: "40px" }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "#000000",
                      marginRight: "25px",
                    }}
                  >
                    For New Customer
                  </span>
                  <div className="skip">
                    <button
                      name="next"
                      className="custom_back"
                      onClick={handleSkipClick}
                    >
                      Click Here
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="menu_link_section">
              <div className="content_box">
                <div className="form-card">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <div className="cus_img">
                        <img
                          src={searchImage}
                          className="w-100"
                          alt="search-img"
                        />
                      </div>
                    </div>

                    <div className="col-md-8">
                      <form className="cus_search">
                        <div className="cus_form">
                          <div className="custom_filed custom_basic">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label
                                    htmlFor="customerName"
                                    className="basic"
                                  >
                                    To regenerate or modify an existing proposal{" "}
                                    <br></br>
                                    <br></br>
                                    Search Customer
                                  </label>
                                  <input
                                    type="search"
                                    className="form-control"
                                    placeholder="Enter Customer Name"
                                    id="customerName"
                                    autoComplete="off"
                                    onChange={(e) =>
                                      setSearchName(e.target.value)
                                    }
                                  />
                                  <div className="search_icon">
                                    <img src={searchIcon} alt="search-icon" />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6 col-6">
                                <div className="form-group">
                                  <label htmlFor="fromDate" className="basic">
                                    Form Date
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="From"
                                    id="fromDate"
                                    onChange={(e) => {
                                      const date = new Date(e.target.value);
                                      const formattedDate = `${String(
                                        date.getDate()
                                      ).padStart(2, "0")}-${String(
                                        date.getMonth() + 1
                                      ).padStart(
                                        2,
                                        "0"
                                      )}-${date.getFullYear()}`;
                                      setFromDate(formattedDate);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-6 col-6">
                                <div className="form-group">
                                  <label htmlFor="toDate" className="basic">
                                    To Date
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="To"
                                    id="toDate"
                                    disabled={!fromDate}
                                    onBlur={(e) => {
                                      const dateValue = e.target.value;

                                      // Ensure the user has selected a valid date
                                      if (!dateValue) {
                                        return;
                                      }

                                      const date = new Date(dateValue);
                                      const formattedDate = `${String(
                                        date.getDate()
                                      ).padStart(2, "0")}-${String(
                                        date.getMonth() + 1
                                      ).padStart(
                                        2,
                                        "0"
                                      )}-${date.getFullYear()}`;

                                      // Parse fromDate and calculate the 3-month limit
                                      const fromDateObj = new Date(
                                        fromDate.split("-").reverse().join("-")
                                      );
                                      const threeMonthsLater = new Date(
                                        fromDateObj
                                      );
                                      threeMonthsLater.setMonth(
                                        threeMonthsLater.getMonth() + 3
                                      );

                                      // Validate if toDate is within 3 months of fromDate
                                      if (date > threeMonthsLater) {
                                        alert(
                                          "To Date cannot be more than 3 months after From Date."
                                        );
                                        e.target.value = ""; // Reset the input field
                                        setToDate(""); // Reset the state
                                        return;
                                      }

                                      setToDate(formattedDate);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="next_btn text-center">
                              {error && <p className="text-danger">{error}</p>}{" "}
                              {/* Display error message */}
                              <button
                                type="button"
                                name="next"
                                className="custom"
                                onClick={handleSearchClick}
                              >
                                Search Customer
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && <Spinner />}
    </section>
  );
};

export default CustomerSearch;
